export default function PhoneServiceProvider() {
  this.$get = () => {
    'ngInject';

    if (!String.prototype.startsWith) {
      String.prototype.startsWith = (searchString, position) => {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
      };
    }

    function PhoneService() {

      const self = this;

      const phones = {
        'US': 1,	// (1)-N*3-N*2-10
        'AT': 43,   // (43)-
        'AU': 61,	// (61)-N*10
        'BE': 32,	// (32)-N*8
        'BR': 55,   // (55)-N*11
        'BY': 37,	// (45)-N*8
        'CA': 1,	// (1)-N*3-N*2-10
        'CH': 41,	// (41)-n*9
        'CZ': 420,
        'DE': 49,	// (49)-N*9
        'DK': 45,	// (45)-N*8
        'EE': 372,
        'ES': 34,	// (34)-N*9
        'FI': 358,
        'FR': 33,	// (33)-N*9
        'GB': 44,	// (44)-N*10
        'GR': 30,
        'IE': 353,	// (353)-N*9
        'IT': 39,	// (39)-n*9
        'LT': 370,
        'LU': 352,
        'LV': 371,
        'MY': 60,
        'MX': 52,
        'NL': 31,	// (31)-N*93
        'NO': 47,
        'NZ': 64,
        'PL': 48,
        'PT': 351,
        'SE': 46,
        'SI': 386,
        'SK': 421,
      };

      self.getCountries = () => {
        const countries = [];

        for (const c in phones) {
          countries.push({
            id: c,
            value: phones[c]
          });
        }

        return countries;
      };

      self.getCountryById = id => {
        return {
          id: id,
          value: phones[id]
        };
      };

      self.getNumberPrefix = country => {
        if ((country) === 'CA') {
          return '+(' + phones[country] + ') ';
        }

        return '+ (' + phones[country] + ') ';
      };

      self.getCountryFromNumber = number => {
        if (number.startsWith('+(', 0)) {
          return 'CA';
        }

        number = number.replace(/\D/g, '');
        /* Remove all not a number symbols */

        for (const c in phones) {
          if (number.startsWith(phones[c], 0)) {
            return c;
          }
        }

        return 'US';
      };

      self.validateNumber = (number, minlength) => {
        const trimmed = number.replace(/\s/g, '');
        const countryCodeEndPosition = trimmed.indexOf(')');
        return trimmed.length - countryCodeEndPosition > minlength;
      };

      self.getCountyType = cntr => {
        if (cntr === 'US' || cntr === 'CA') {
          return 1;
        } else if (cntr === 'IE') {
          return 2;
        } else if (cntr !== 'US' && cntr !== 'CA' && cntr !== 'IE') {
          return 3;
        }
      }

      self.formNumber = (country, numberStr, changed, prevCountry) => {
        const numberPrefix = self.getNumberPrefix(country);
        let number = numberStr.replace(/\D/g, '');
        /* Remove all not a number symbols */

        if (!number.length) {
          return numberPrefix;
        }

        if (number.length > 15) {
          number = number.substr(0, 15);
        }

        number = number.split('');
        /* To Array */

        if (!changed) {
          //Add code country separators
          if (self.getCountyType(country) === 1) {
            number.splice(0, 1, numberPrefix);
          } else if (self.getCountyType(country) === 2) {
            number.splice(0, 3, numberPrefix);
          } else if (self.getCountyType(country) === 3) {
            number.splice(0, 2, numberPrefix);
          }
        } else {
          //Add code country separators
          if (self.getCountyType(prevCountry) === 1) {
            number.splice(0, 1, numberPrefix);
          } else if (self.getCountyType(prevCountry) === 2) {
            number.splice(0, 3, numberPrefix);
          } else if (self.getCountyType(prevCountry) === 3) {
            number.splice(0, 2, numberPrefix);
          }
        }

        //Add first number separators
        if (number.length > 4) {
          number.splice(4, 0, ' ');
        }

        //Add second number separators
        if (number.length > 8) {
          number.splice(8, 0, ' ');
        }

        //Add third separator for USA
        if (number.length > 13) {
          number.splice(13, 0, ' ');
        }

        return number.join('');
        /* To String */
      };

      self.getDefaultCountry = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;
              const latlng = new window.google.maps.LatLng(lat, lng);

              new window.google.maps.Geocoder().geocode({'latLng': latlng}, (results, status) => {
                if (status === window.google.maps.GeocoderStatus.OK) {
                  /*Parse result to get country*/
                  for (const r in results) {
                    const types = results[r].types;

                    for (const t in types) {
                      const type = types[0]; // ???? TODO

                      if (type === 'country') {
                        for (const c in phones) {
                          if (c === results[r].formatted_address) {
                            return c;
                          }
                        }
                      }
                    }
                  }
                }

                return self.getCountryById('US');
              });
            },
            e => {
              //Use Default Country
              return self.getCountryById('US');
            });
        } else {
          //Use Default Country
          return self.getCountryById('US');
        }
      };

    }

    return new PhoneService();
  };
}